<template>
	<div v-if="show" class="invalidUser fullscreen-centered always-on-top dark-stars">
		<div class="closeButton"><a href="#" v-on:click="close"><i class="fas fa-times"></i></a></div>
		<div class="p-1">
			<Logo/>
			<div><h2>{{ errorTitle }}</h2></div>
			<div><h5 v-html="errorMessage"></h5></div>
			<div class="button-row"><button class="blue" v-on:click="close">{{ btnText ? btnText : "Try Again" }}</button></div>
		</div>
	</div>
</template>

<script>
import Logo from "@/components/Logo.vue";

export default {
	name: 'ErrorPopup',
	components: {
		Logo
	},
	props: {
		show: {
			type: Boolean,
			required: true
		},
		errorTitle: {
			type: String,
			default: "Error"
		},
		errorMessage: {
			type: String,
			required: true
		},
		btnText: {
			type: String,
			default: "Try Again"
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
	}
}
</script>

<style scoped>

</style>